import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { lookupsJson } from '@ourbranch/lookups';
import Field from 'core/components/form/form.v2';
import { Label } from 'core/components/label';

import useStyles from './mobile-home-form.styles';

// Form options constants
const electricalServiceOptions = lookupsJson.farm.electricalService;
const electricalTypesOptions = lookupsJson.farm.electricalType;
const fireProtectiveDevicesOptions = lookupsJson.farm.fireProtectiveDevice;
const heatingTypeOptions = lookupsJson.farm.heatingType;
const mobileHomeQualityGradeOptions = lookupsJson.farm.mobileHomeQualityGrade;
const heatingSourceOptions = lookupsJson.farm.primaryHeatingSourceOptions;
const tieDownTypeOptions = lookupsJson.farm.tieDownTypes;
const constructionTypeOptions = lookupsJson.farm.dwellingConstructionType;
const mobileHomeConfigOptions = lookupsJson.farm.mobileHomeConfig;

const roofShapeOptions = lookupsJson.roofShape;
const roofTypeOptions = lookupsJson.farm.mobileHomeRoofType;
const theftPreventionDevicesOptions = lookupsJson.farm.theftProtectiveDevice;

const MobileHomeForm = ({
  basePath,
  isSelectedHeatingSourceUnitCountBased,
  isSelectedSecondaryHeatingSourceUnitCountBased,
  disableRiskForm,
  initialBuilding,
  initialConnectedHome,
  toastRCEWarning,
  state
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12}>
        <Label type="infoTitleSmall">Residents</Label>
      </Grid>
      <Field
        xs={6}
        type="select"
        name={`${basePath}.building.ownershipStatus`}
        id={`${basePath}.building.ownershipStatus`}
        mode="light"
        label="Ownership"
        options={lookupsJson.ownershipStatus}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.ownershipStatus) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        name={`${basePath}.building.numOccupants`}
        id={`${basePath}.building.numOccupants`}
        type="numeric"
        label="Residents"
        format={{
          allowNegative: false
        }}
        mode="light"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.numOccupants) {
            toastRCEWarning?.();
          }
        }}
      />
      <Grid item xs={12}>
        <Label type="infoTitleSmall">Property</Label>
      </Grid>
      <Field
        xs={4}
        name={`${basePath}.building.yearBuilt`}
        id={`${basePath}.building.yearBuilt`}
        type="numeric"
        label="Year built in"
        mode="light"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.yearBuilt) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${basePath}.building.sqFt`}
        name={`${basePath}.building.sqFt`}
        mode="light"
        label="Total finished sqft"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.sqFt) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        type="select"
        options={constructionTypeOptions}
        id={`${basePath}.building.constructionType`}
        name={`${basePath}.building.constructionType`}
        mode="light"
        label="Construction type"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.constructionType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        options={mobileHomeQualityGradeOptions}
        id={`${basePath}.building.mobileHomeQualityGrade`}
        name={`${basePath}.building.mobileHomeQualityGrade`}
        mode="light"
        label="Home quality"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.mobileHomeQualityGrade) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        options={mobileHomeConfigOptions}
        id={`${basePath}.building.mobileHomeConfig`}
        name={`${basePath}.building.mobileHomeConfig`}
        mode="light"
        label="Mobile home config"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.mobileHomeConfig) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${basePath}.building.roofYear`}
        name={`${basePath}.building.roofYear`}
        mode="light"
        label="Roof year"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.roofYear) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        id={`${basePath}.building.roofType`}
        name={`${basePath}.building.roofType`}
        type="select"
        options={roofTypeOptions}
        mode="light"
        label="Roof type"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.roofType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        id={`${basePath}.building.roofShape`}
        name={`${basePath}.building.roofShape`}
        type="select"
        options={roofShapeOptions}
        mode="light"
        label="Roof shape"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.roofShape) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        type="string"
        id={`${basePath}.building.constructionStyle`}
        name={`${basePath}.building.constructionStyle`}
        mode="light"
        label="Areas under construction"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.constructionStyle) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        id={`${basePath}.building.tieDownType`}
        name={`${basePath}.building.tieDownType`}
        mode="light"
        label="Tie down type"
        options={tieDownTypeOptions}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.tieDownType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={12}
        type="numeric"
        id={`${basePath}.building.numSolidFuelBurningAppliances`}
        name={`${basePath}.building.numSolidFuelBurningAppliances`}
        mode="light"
        label="Num solid fuel burning appliances in dwelling or related private structures?"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.numSolidFuelBurningAppliances) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={3}
        id={`${basePath}.building.primaryHeatingSource`}
        name={`${basePath}.building.primaryHeatingSource`}
        type="select"
        options={heatingSourceOptions}
        mode="light"
        label="Primary heating"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.primaryHeatingSource) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={3}
        type="numeric"
        id={`${basePath}.building.numHeatingSources`}
        name={`${basePath}.building.numHeatingSources`}
        mode="light"
        label="Heating units"
        disabled={disableRiskForm || !isSelectedHeatingSourceUnitCountBased}
        onChange={(val) => {
          if (val !== initialBuilding.numHeatingSources) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={3}
        id={`${basePath}.building.secondaryHeatingSource`}
        name={`${basePath}.building.secondaryHeatingSource`}
        type="select"
        options={heatingSourceOptions}
        mode="light"
        label="Secondary heating"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.secondaryHeatingSource) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={3}
        type="numeric"
        id={`${basePath}.building.numSecondaryHeatingSources`}
        name={`${basePath}.building.numSecondaryHeatingSources`}
        mode="light"
        label="Heating units"
        disabled={disableRiskForm || !isSelectedSecondaryHeatingSourceUnitCountBased}
        onChange={(val) => {
          if (val !== initialBuilding.numSecondaryHeatingSources) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        id={`${basePath}.building.renovation.electricalType`}
        name={`${basePath}.building.renovation.electricalType`}
        type="select"
        options={electricalTypesOptions}
        mode="light"
        label="Electric type"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.renovation?.electricalType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        id={`${basePath}.building.renovation.electricalService`}
        name={`${basePath}.building.renovation.electricalService`}
        type="select"
        options={electricalServiceOptions}
        mode="light"
        label="Electrical service update"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.renovation?.electricalService) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        id={`${basePath}.building.renovation.heatingType`}
        name={`${basePath}.building.renovation.heatingType`}
        type="select"
        options={heatingTypeOptions}
        mode="light"
        label="Heating Type"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.renovation?.heatingType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${basePath}.building.renovation.heatingYear`}
        name={`${basePath}.building.renovation.heatingYear`}
        mode="light"
        label="Heating year"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.renovation?.heatingYear) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${basePath}.building.renovation.coolingYear`}
        name={`${basePath}.building.renovation.coolingYear`}
        mode="light"
        label="AC year"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.renovation?.coolingYear) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${basePath}.building.renovation.plumbingYear`}
        name={`${basePath}.building.renovation.plumbingYear`}
        mode="light"
        label="Plumbing year"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.renovation?.plumbingYear) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        id={`${basePath}.connectedHome.theftPreventionDeviceType`}
        name={`${basePath}.connectedHome.theftPreventionDeviceType`}
        type="select"
        options={theftPreventionDevicesOptions}
        mode="light"
        label="Theft protective device"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialConnectedHome?.theftPreventionDeviceType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Field
        xs={6}
        id={`${basePath}.connectedHome.fireProtectiveDeviceType`}
        name={`${basePath}.connectedHome.fireProtectiveDeviceType`}
        options={fireProtectiveDevicesOptions}
        type="select"
        mode="light"
        label="Fire protective device"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialConnectedHome?.fireProtectiveDeviceType) {
            toastRCEWarning?.();
          }
        }}
      />
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <Field
          name={`${basePath}.building.enclosedMasonryFoundation`}
          id={`${basePath}.building.enclosedMasonryFoundation`}
          type="checkbox"
          label="Enclosed masonry foundation?"
          mode="light"
          disabled={disableRiskForm}
          className={classes.checkboxContainer}
          onChange={(val) => {
            if (val !== initialBuilding?.enclosedMasonryFoundation) {
              toastRCEWarning?.();
            }
          }}
        />
      </Grid>
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <Field
          name={`${basePath}.building.fullSkirtingAroundBase`}
          id={`${basePath}.building.fullSkirtingAroundBase`}
          type="checkbox"
          label="Is there a full skirting around the base?"
          mode="light"
          disabled={disableRiskForm}
          className={classes.checkboxContainer}
          onChange={(val) => {
            if (val !== initialBuilding?.fullSkirtingAroundBase) {
              toastRCEWarning?.();
            }
          }}
        />
      </Grid>
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <Field
          name={`${basePath}.building.solarPanelsAttached`}
          id={`${basePath}.building.solarPanelsAttached`}
          type="checkbox"
          label="Are there solar panels attached to this dwelling?"
          mode="light"
          disabled={disableRiskForm}
          className={classes.checkboxContainer}
          tooltipText="If solar panels are attached to this dwelling, it should be included here so that it can be included in this risk's property details. If they are not attached, but the client wants coverage on them, they should be included under personal property (coverage E)."
          tooltipLabel="More Info"
          onChange={(val) => {
            if (val !== initialBuilding?.solarPanelsAttached) {
              toastRCEWarning?.();
            }
          }}
        />
      </Grid>
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <Field
          name={`${basePath}.connectedHome.internetMonitoring`}
          id={`${basePath}.connectedHome.internetMonitoring`}
          type="checkbox"
          label="Internet connected monitoring device(s)?"
          mode="light"
          disabled={disableRiskForm}
          className={classes.checkboxContainer}
          onChange={(val) => {
            if (val !== initialConnectedHome?.internetMonitoring) {
              toastRCEWarning?.();
            }
          }}
        />
      </Grid>
    </>
  );
};

MobileHomeForm.propTypes = {
  basePath: PropTypes.string.isRequired,
  isSelectedHeatingSourceUnitCountBased: PropTypes.bool,
  isSelectedSecondaryHeatingSourceUnitCountBased: PropTypes.bool,
  disableRiskForm: PropTypes.bool,
  initialBuilding: PropTypes.object,
  initialConnectedHome: PropTypes.object,
  toastRCEWarning: PropTypes.func,
  state: PropTypes.string
};

export default MobileHomeForm;
